export default __webpack_public_path__ + "static/media/proff-photo.7500e386.png";